import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, Col, Comment, Divider, Input, List, Row, Skeleton } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import MaintenanceService from '../../../../../services/maintenance';
import { errorNotification, successNotification } from '../../../../../components/UI/Notifications/Notifications';


const WorkOrderCommentsTab = () => {
    const {workOrderId} = useParams();

    const hid = useSelector(state => state.ui.selectedHotel ?? 0);
    const userId = useSelector(state => state.auth.user?.id ?? 0);
    const username = useSelector(state => state.auth.user?.username ?? '');

    const [loading, setLoading] = useState(true);
    const [submitted, setSubmitted] = useState(false);
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState("");

    useEffect(() => {
        if (workOrderId != null) {
            loadData();
        }
    }, [workOrderId]);

    const loadData = async () => {
        await MaintenanceService.getWorkOrderComments(workOrderId)
            .then(res => {
                if (res != null) {
                    const rev = res.toReversed();
                    setComments(rev);
                }
            })
            .catch(err => errorNotification(err))
            .finally(() => setLoading(false));
    };

    const renderTimestamp = (a, u) => {
        if (a == null || a[0] === -999999999) { return ''; }

        return new Date(a[0], (a[1] - 1), a[2], a[3], a[4], a[5] || 0).toLocaleString('es-mx', {timeZone: 'America/Los_Angeles'});
    };


    const addComment = () => {
        setLoading(true);
        
        if (!submitted) {
            setSubmitted(true);

            MaintenanceService.addWorkOrderComment(workOrderId, new Date().getTime(), userId, username, newComment)
                .then(() => successNotification('El comentario se ha enviado exitosamente'))
                .catch(err => errorNotification(err))
                .finally(() => {
                    loadData();
                    setSubmitted(false);
                });
        }
    };

    return (
        <Skeleton loading={loading} paragraph={{rows: 9, cols: 1}} active>
            <Row style={{display: 'flex', width: '100%', marginTop: 10}}>
                <Row style={{width: '100%', height: 40}}>
                    <Col span={22} style={{display: 'flex', alignItems: 'center', height: '100%'}}><span style={{marginLeft: 20, width: '100%'}}>
                        <Input style={{width: '95%'}} onChange={(e) => setNewComment(e.target.value)} disabled={loading || submitted}/></span>
                        <Button type="primary" style={{marginLeft: 5}} onClick={() => addComment()}>Agregar comentario</Button>
                    </Col>
                </Row>

                <Divider/>

                <List
                    itemLayout="horizontal"
                    dataSource={comments}
                    renderItem={(item) => (
                        <li>
                            <Comment
                                author={item.username}
                                content={item.message}
                                datetime={renderTimestamp(item.timestamp)}
                            />
                        </li>
                    )}
                />              
            </Row>
        </Skeleton>
    );
};

export default WorkOrderCommentsTab;